<!--Generally I don't like components that render nothing in some cases. I'd prefer-->
<!--the calling component check whether anything should be rendered. But it seems ok here.-->
<div *ngIf="!globalVars.loggedInUser" class="d-lg-none d-block">
  <a (click)="globalVars.launchLoginFlow('top-bar-mobile-signup-button')" class="font-weight-bold">
    {{ "top_bar.mobile.signup" | transloco }}
  </a>
</div>
